<template>
  <div>
    <div class="font-weight-bold grey--text text--darken-1">Adicione o Favicon</div>
    <v-card outlined :disabled="!isActivePlan" class="pa-6 pt-4 mt-3 d-flex align-center">
      <img style="width: 25px; position: relative; top: 2px;" class="mr-3" :src="value" v-if="value" />
      <v-file-input
        accept="image/png, image/jpeg, image/gif, image/ico"
        clearable
        :rules="rules"
        v-model="favicon"
        placeholder="clique para inserir"
        label="Faça upload do Favicon (16x16 gif, png, jpg, ico)"
        hide-details
        append-icon="mdi-upload"
        :prepend-icon="value ? '' : 'mdi-image'"
        :loading="loading"
      >
      </v-file-input>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
import CloudFunctionService from '@/services/CloudFunctionService'

export default {
  props: ['value'],
  data () {
    return {
      favicon: null,
      loading: false,
      rules: [
        value => !value || value.size < 250000 || 'O Favicon não pode ultrapassar 250 Kb!'
      ]
    }
  },
  computed: {
    ...mapGetters({
      project: 'projects/getSelected'
    }),
    ...mapState({
      user: state => state.auth.user
    }),
    isActivePlan () {
      return moment(this.user.active_plan_at || 0).valueOf() > Date.now() || this.project.user_id !== this.user.id
    }
  },
  watch: {
    favicon: function (favicon) {
      if (favicon) {
        this.upload(favicon)
      }
    }
  },
  methods: {
    async upload (favicon = this.favicon) {
      this.loading = true
      try {
        const url = await CloudFunctionService.upload({ image: favicon, userId: this.user.id })
        this.$emit('input', url)
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>